import { AugmentationPanelLegacyForm } from "@pathwright/ux/src/components/augmentation/AugmentationPanelLegacyForm"
import { ManageMentorGroupContainer } from "../manage/ManageMentorGroupCard"

function GroupManageAugmentation({ groupId }: { groupId: number }) {
  return (
    <AugmentationPanelLegacyForm cardFieldPadding>
      <ManageMentorGroupContainer id={groupId} />
    </AugmentationPanelLegacyForm>
  )
}

export default GroupManageAugmentation
